import _ from 'lodash';
import httpStatus from 'http-status';

import { after } from 'scripts/infrastructure/backends/http_client';
import Observable from 'scripts/lib/observable_mixin';

export default class EndpointGateway {
  constructor(backend) {
    this.backend = backend;
  }

  init({ orgId }) {
    this.orgId = orgId;
  }

  get http() {
    return this.backend.axios();
  }

  update(endpointId, endpointAttrs) {
    after(
      this.http.put(`${endpointUrl(this.orgId, endpointId)}`, endpointAttrs),
      this.updateHandler.bind(this, endpointId)
    );
  }

  updateHandler(endpointId, err, res) {
    if (_.get(res, 'status') === httpStatus.NO_CONTENT) {
      this.notifyObservers('handleUpdateSuccess', endpointId, res.response);
      return;
    }

    const responseErr = err || res || new Error('unable to update endpoint');
    this.notifyObservers('handleUpdateErrors', endpointId, responseErr);
  }
}

export function endpointUrl(orgId, endpointId) {
  return endpointId
    ? `/api/v1/orgs/${orgId}/configurations/endpoints/${endpointId}`
    : `/api/v1/orgs/${orgId}/configurations/endpoints/`;
}

_.extend(EndpointGateway.prototype, Observable);



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/endpoint_http_gateway.js